import { useToast } from "./Toast";
import { useI18n } from "@/shared/i18n";

interface Props {
  value: string;
  label?: string;
  note?: string;
}

/** One-time secret (API key) display with copy. The server returns it once, so
 *  we warn the user to save it now. */
export function SecretReveal({ value, label = "API Key", note }: Props) {
  const toast = useToast();
  const { t } = useI18n();
  async function copy() {
    try {
      await navigator.clipboard.writeText(value);
      toast.success(t("Copied"));
    } catch {
      toast.error(t("Copy failed — select it manually"));
    }
  }
  return (
    <div className="secret">
      <div className="secret__label">
        {label} {t("(shown only once — save it now)")}
      </div>
      <div className="secret__row">
        <code className="secret__val mono">{value}</code>
        <button className="copy-btn" type="button" onClick={copy}>
          {t("Copy")}
        </button>
      </div>
      {note && <div className="secret__note">{note}</div>}
    </div>
  );
}
